// Recovered compiled webpack factory 43275. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { Ow: () => i, Yz: () => d, Z9: () => s, pq: () => l });
  var n = r(60057),
    a = r(61571),
    o = r(49636);
  let i = ["debug", "info", "warn", "error", "log", "assert", "trace"],
    s = {};
  function l(e) {
    if (!("console" in o.O)) return e();
    let t = o.O.console,
      r = {},
      n = Object.keys(s);
    n.forEach((e) => {
      let n = s[e];
      ((r[e] = t[e]), (t[e] = n));
    });
    try {
      return e();
    } finally {
      n.forEach((e) => {
        t[e] = r[e];
      });
    }
  }
  function u() {
    return f().enabled;
  }
  function c(e, ...t) {
    a.T &&
      u() &&
      l(() => {
        o.O.console[e](`Sentry Logger [${e}]:`, ...t);
      });
  }
  function f() {
    return a.T ? (0, n.BY)("loggerSettings", () => ({ enabled: !1 })) : { enabled: !1 };
  }
  let d = {
    enable: function () {
      f().enabled = !0;
    },
    disable: function () {
      f().enabled = !1;
    },
    isEnabled: u,
    log: function (...e) {
      c("log", ...e);
    },
    warn: function (...e) {
      c("warn", ...e);
    },
    error: function (...e) {
      c("error", ...e);
    },
  };
}
